import { z } from 'zod';
/** Small viewport captures from the isolated trusted observer, bound by its signed receipt. */
export const fieldBrowserCaptureSchema = z.strictObject({
    id: z.enum(['initial', 'trade', 'recovery']),
    capturedAt: z.iso.datetime(),
    url: z
        .string()
        .max(500)
        .refine((value) => {
        try {
            const url = new URL(value);
            return url.origin === 'http://127.0.0.1:8080' && !url.username && !url.password;
        }
        catch {
            return false;
        }
    }, 'Capture must belong to the isolated application'),
    mimeType: z.literal('image/jpeg'),
    imageBase64: z
        .string()
        .min(4)
        .max(64_000)
        .regex(/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/),
    imageSha256: z.string().regex(/^[a-f0-9]{64}$/),
    width: z.number().int().min(1).max(1600),
    height: z.number().int().min(1).max(1200),
    visibleText: z.string().max(6000),
    textTruncated: z.boolean(),
    controls: z
        .array(z.strictObject({
        role: z.string().max(40),
        name: z.string().max(100),
        disabled: z.boolean(),
    }))
        .max(40),
});
/** Trusted controller launch receipt; candidate self-reported build IDs are not used. */
export const fieldBrowserObservationSchema = z.strictObject({
    deploymentId: z.uuid(),
    sourceRevision: z.string().regex(/^[a-f0-9]{64}$/),
    applicationImage: z.string().regex(/^sha256:[a-f0-9]{64}$/),
    observerImage: z.string().regex(/^sha256:[a-f0-9]{64}$/),
    controllerVersion: z.literal('ladder-browser.v1'),
    scope: z.literal('isolated_candidate_replica'),
    startedAt: z.iso.datetime(),
    finishedAt: z.iso.datetime(),
    identityVerified: z.boolean(),
    browserVersion: z.string().max(100),
    limitations: z.array(z.string().max(1000)).max(10),
    captures: z.array(fieldBrowserCaptureSchema).max(3).optional(),
});
